module.exports = __webpack_public_path__ + "static/media/corporate-services-img57.8992e257.jpg";